import { render, staticRenderFns } from "./RoomTabComponent.vue?vue&type=template&id=2e20b6cd&scoped=true&"
import script from "./RoomTabComponent.vue?vue&type=script&lang=ts&"
export * from "./RoomTabComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e20b6cd",
  null
  
)

export default component.exports